export const defaultTypingRateColor = "gold";

export function GetInsertedCharacterCount(
    previousValue: string,
    nextValue: string
): number {
    if (nextValue.length <= previousValue.length) {
        return 0;
    }

    let prefixLength = 0;
    while (
        prefixLength < previousValue.length &&
        prefixLength < nextValue.length &&
        previousValue[prefixLength] === nextValue[prefixLength]
    ) {
        prefixLength++;
    }

    let suffixLength = 0;
    while (
        suffixLength < previousValue.length - prefixLength &&
        suffixLength < nextValue.length - prefixLength &&
        previousValue[previousValue.length - 1 - suffixLength] ===
            nextValue[nextValue.length - 1 - suffixLength]
    ) {
        suffixLength++;
    }

    return Math.max(0, nextValue.length - prefixLength - suffixLength);
}

export function GetTypingRateOpacity(charactersPerSecond: number): number {
    if (charactersPerSecond <= 0) {
        return 0;
    }

    if (charactersPerSecond >= 3) {
        return 0.55;
    }

    const clampedCharactersPerSecond = Math.min(
        3,
        Math.max(0, charactersPerSecond)
    );

    return 0.25 + (clampedCharactersPerSecond / 3) * (0.55 - 0.25);
}

export function GetTypingRateColor(charactersPerSecond: number): string {
    if (charactersPerSecond >= 4) {
        return "#ff9f3f";
    }

    if (charactersPerSecond >= 2) {
        return "yellowgreen";
    }

    return defaultTypingRateColor;
}
